import React from "react";

const HeadingOne = ({ className, children }) => {
  return <h1 className={`${className} text-3xl font-poppins`}>{children}</h1>;
};

HeadingOne.defaultProps = {
  className: "",
};
export default HeadingOne;
